import type { ReactNode } from 'react';

import { DialogContent } from '../../../../../components/Dialog/DialogUiRedesign/DialogContent';
import { DialogHeader } from '../../../../../components/Dialog/DialogUiRedesign/DialogHeader';

import styles from './PocViewConstructor.module.scss';

export function PocViewConstructor(props: {
  title: ReactNode;
  content: ReactNode;
  onGoBack?: VoidFunction;
  onClose?: VoidFunction;
}) {
  return (
    <div className={styles.container}>
      <DialogHeader
        title={props.title}
        titleClassName={styles.header}
        onClose={props.onClose}
        onGoBack={props.onGoBack}
      />
      <DialogContent>{props.content}</DialogContent>
    </div>
  );
}
